import { render, staticRenderFns } from "./tabeLgota.vue?vue&type=template&id=09342af4"
import script from "./tabeLgota.vue?vue&type=script&lang=js"
export * from "./tabeLgota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports